module.exports = __webpack_public_path__ + "img/font_logo.333b768b.png";